import Skelet from '../Skelet';
import styles from '../../styles/modules/objects/ObjectsMapCatalogItem.module.scss';

const ObjectsMapCatalogSkeletonItem = () => {
  return (
    <div className={styles.item}>
      <div className={styles.itemGallery}>
        <Skelet style={{ height: '100%', borderRadius: 10, margin: 2, width: 'auto' }} />
      </div>
      <div className={styles.itemData}>
        <Skelet className={styles.itemPrice} height={36} maxWidth={200} />
        <Skelet className={styles.itemAddress} height={21} maxWidth={240} />
        <div className={styles.itemProperties}>
          <Skelet
            className={styles.itemProperty}
            width={60}
            height={32}
            style={{ marginRight: 12 }}
          />
          <Skelet
            className={styles.itemProperty}
            width={60}
            height={32}
            style={{ marginRight: 12 }}
          />
          <Skelet
            className={styles.itemProperty}
            width={60}
            height={32}
            style={{ marginRight: 12 }}
          />
        </div>
        <div className={styles.itemActions}>
          <Skelet height={50} style={{ borderRadius: 12, width: '100%' }} />
        </div>
      </div>
    </div>
  );
};

export default ObjectsMapCatalogSkeletonItem;
